import { Button, message, Table, Space } from "antd";
import { useEffect, useState } from "react";
import { getPaymentVidName, getTableColumn } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import ClientPaymentChange from "./client-payment-change";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { isMobile } from "../../extensions/design";
import ClientItemAbonPayment from "./client-item-abon-payment";
import { fmtDate, strDate2Server } from "../../extensions/utils";

const ClientAbonItemPayments = ({ id, onAbonsUpdate, abon }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const user = useSelector((s) => s.user);
  const [isPayed, setIsPayed] = useState(false);
  const [isDebet, setIsDebet] = useState(false);
  const getPaymentsData = () => {
    setLoading(true);
    serverFetch(`Payment/BySale/${id}`)
      .then((data) => {
        setItems(data.map(i => ({ ...i, docDate: dayjs(i.docDate) })));
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  useEffect(() => {
    getPaymentsData();
  }, []);

  useEffect(() => {
    setIsPayed(abon.paid > 0);
    setIsDebet(abon.debet > 0);
  }, [abon]);

  const onRowClick = record => {
    if (record.id === selectedId) { // если клик по той же строке
      if (record.id === 0) handleClose(false);
      else setSelectedId(null);
    } else {
      if (selectedId === 0) // если текущая выделенная строка временная, удаляем её
        handleClose(false);
      setSelectedId(record.id);
    }
  };
  const handleClose = (refresh) => {
    setSelectedId(null);
    refresh ? getPaymentsData() : setItems([...items.filter(i => i.id !== 0)]);
    refresh && onAbonsUpdate();
  };
  
  const onCloseFunction = () => {
    onAbonsUpdate();
    getPaymentsData();
    setSelectedId(null);
  }

  const serviceColumns = [
    getTableColumn("id", "#", { width: 80, type: "number" }),
    getTableColumn("vid", "Вид", { width: 80, render: getPaymentVidName } ),
    getTableColumn("paymentVidName", "Вид оплаты",  {width: 250, type: "string" }),
    getTableColumn("saleDocDate", "Дата оплаты", { width: 120, type: "date", formatFn: fmtDate }),
    getTableColumn("syma", "Сумма", { width: 100, type: "number" }),
  ];

  const onAddAvans = () => {
    setItems([{id: 0, docDate: dayjs(), syma: abon.debet, saleId: id, vid: 1, clientId: abon.clientId, userId: user.id }, ...items.filter(i => i.id)]);
    setSelectedId(0);
  }

  const onAddReturn = () => {
    setItems([{id: 0, docDate: dayjs(), syma: abon.syma - abon.debet, saleId: id, vid: -1, clientId: abon.clientId, userId: user.id }, ...items.filter(i => i.id)]);
    setSelectedId(0);
  }
  const content = !isMobile ? [
    <>
      <Space style={{ marginLeft: "24px", marginBottom: "12px" }}>
        <Button className="sport-btn" onClick={onAddAvans} disabled={!isDebet || abon.status === 5 || abon.deleted}>Аванс</Button>
        <Button className="sport-btn" onClick={onAddReturn} disabled={!isPayed || abon.status === 5 || abon.deleted}>Возврат</Button>  
      </Space>
      <Table dataSource={items} loading={loading} columns={serviceColumns} rowKey="id" size="small" className="table-detail" pagination={false} expandable={{
          expandedRowRender: record => <ClientPaymentChange paymentItem={record} onClose={handleClose}/>,
          expandedRowKeys: [selectedId],
          onExpand: (expanded, record) => {
            if (!expanded && record.id === 0) { // Для удаления временной строки при её сворачивании
              handleClose(false);
            } else {setSelectedId(expanded ? record.id : null);}
          },
          expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
          expandIconColumnIndex: serviceColumns.length,
          rowExpandable: () => true,
          className: "cl-abons-expandable",
        }}
        onRow={(record) => ({ onClick: () => onRowClick(record)})}
        rowClassName={(_, index) => (index % 2 === 0 ? "row-even" : "row-odd")}
        summary={(pageData) => {
          const totalPayment = pageData.reduce((total, item) => {
            if (item.id === 0) return total;
            const syma = Number(item.syma || 0);
            const sign = item.vid === -1 ? -1 : 1;
            return total + syma * sign;
          }, 0);

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={3}>
                  <b style={{ float: "left" }}>Итого:</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <b style={{ float: "right" }}>{totalPayment.toFixed(2)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </>
  ] : [
    <>
      <div className="client-items" style={{ overflowY: "scroll", overflowX: "clip"}}>
      {items.map((item) => {
        const isExpanded = selectedId == item.id;
          return (
            <div key={item.id}>
              <div onClick={() => setSelectedId(isExpanded ? null : [item.id])} style={{ cursor: "pointer" }}>
                <ClientItemAbonPayment item={item} expanded={isExpanded} setExpanded={setSelectedId} onClose={onCloseFunction}/>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{marginTop: 4}} className="client-item-line-double-halfed">
        <Button onClick={onAddAvans} disabled={!isDebet || abon.status === 5 || abon.deleted}>Аванс</Button>
        <Button onClick={onAddReturn} disabled={!isPayed || abon.status === 5 || abon.deleted}>Возврат</Button>  
      </div>
    </>
  ]
  return (
    <>
      {content}
    </>
  );
};

export default ClientAbonItemPayments;
